import { DomEvent } from "@mcleod/components";
import { MenuItem } from "@mcleod/core";
import { MainMenu } from "./MainMenu";
import { MainMenuTree } from "./MainMenuTree";
import { MenuTreeNode, MenuTreeNodeProps } from "./MenuTreeNode";
import { MenuTreeNodeLeaf } from "./MenuTreeNodeLeaf";

export class MenuTreeNodeBranch extends MenuTreeNode {
    private mainMenu: MainMenu;
    constructor(mainMenu: MainMenu, props: Partial<MenuTreeNodeProps>) {
        super({
            color: "component.palette.menu.mainColor",
            themeKey: "menu.branchNode",
            selectOnHover: true,
            ...props
        });
        this.mainMenu = mainMenu;
        this.label.height = 32;
        for (const item of this.menuItem.items) {
            const childNode = this.createChildNode(item);
            this.addChild(childNode);
        }
    }

    private createChildNode(item: MenuItem): MenuTreeNode {
        if (item.items == null) {
            const node = new MenuTreeNodeLeaf(this.mainMenu, { menuItem: item });
            // When hovering over this node, the background changes to match the selected parent.
            // This aligns the left edge with the parent node
            node.paddingLeft = 20;
            // allows favorite star to align with the stars in panelFavorites.
            node.paddingRight = 4;
            return node;
        } else {
            return new MenuTreeNodeBranch(this.mainMenu, {
                menuItem: item,
                color: "component.palette.menu.secondaryColor"
            });
        }
    }

    protected nodeClicked(event: DomEvent) {
        super.nodeClicked(event);
        if (this.tree) {
            this.tree.selectedNode = this;
        }
    }

    override set expanded(value: boolean) {
        if (this.expanded === value)
            return;
        super.expanded = value;
        if (this.isInitialized) {
            this.label.rotateWithTransition(this.expanded ? 0 : -90, 200);
        }
    }

    override get expanded(): boolean {
        return super.expanded;
    }
}
